import React, { useState, useEffect } from 'react';
import { useQuery } from "react-query";
import { statTypes } from "../shared/components/Table/utils";
import { fetchClient } from "../shared/api/fetching";
import PlayersCareerTable from "./components/PlayersCareerTable";
import { apiURL } from "../shared/api/variables";
import Dropdown from "../shared/components/Dropdown";
import ButtonGroup from "../shared/components/ButtonGroup";
import ToggleButton from "../shared/components/ToggleButton";
import { formatSeasonStatsData } from './utils';
import { useReactAppState } from "../shared/containers/utils";
import { NoResults } from "../shared/svg/Svg";
import mlsEndpoints from '../shared/api/mlsEndpoints';
import { isArrayEmpty } from '../mls-possession/utils';

function PlayersCareerStats({ options }) {
  
  const initialStatType = options?.position === "goalkeeper" ? statTypes.playersCareerStatsGoalKeeping : statTypes.playersCareerStatsGeneral;
  const [order, setOrder] = useState({ id: "date", desc: true });
  const [statType, setStatType] = useState(initialStatType);

  const { t, mediaQueries } = useReactAppState();
  const { isLargeMin } = mediaQueries || {};

  useEffect(() => {
    setOrder({ id: "date", desc: true });
  }, [statType]);
  
  const playerSportecId = options?.player?.fields?.sportecId;
  const competitionSportecId = options?.competitionSportecId;

  const mlsStatsEndpoint = mlsEndpoints.getPlayerCareerStatsByPlayerId
    .replace("{player_id}", playerSportecId)
    .replace("{competition_id}", competitionSportecId);

  const {
    data: statsData,
    isLoading: statsLoading
  } = useQuery({
    queryKey: [`mls-players-career-stats-${playerSportecId}-${competitionSportecId}`],
    queryFn: () => fetchClient({ endpoint: mlsStatsEndpoint, apiURL: apiURL.statsAPI }),
    enabled: !!playerSportecId && !!competitionSportecId
  });

  let formatStatsData = statsData ? formatSeasonStatsData(statsData, competitionSportecId) : [];

  return (
    <>
      {statsLoading ||
        !isArrayEmpty(formatStatsData) ?
        <div role="region" className="mls-c-players-career-stats">
          {options?.title ?
            <>
              <div className="mls-o-block-header">
                <div className="mls-o-block-header__title">
                  {t(options?.title)}
                </div>
              </div>
              <div className="mls-o-block-header mls-o-block-header--sm">
                <div className="mls-o-block-header__title">
                  {t(options?.title)}
                </div>
              </div>
            </>
            : null
          }
          <div className="mls-c-stats__header">
            {
              isLargeMin
                ? (
                  <ButtonGroup
                    className={'mls-o-buttons__segmented mls-o-buttons__segmented--four desktop'}
                    value={statType}
                    onChange={(e) => setStatType(e.target.value)}
                    aria-label="statistics category"
                  >
                    <ToggleButton className="mls-o-buttons__segment" value={initialStatType} aria-label="general">
                      {t("stats_general")}
                    </ToggleButton>
                    <ToggleButton className="mls-o-buttons__segment" value={statTypes.playersCareerStatsPassing} aria-label="passing">
                      {t("stats_passing")}
                    </ToggleButton>

                    <ToggleButton className="mls-o-buttons__segment" value={statTypes.playersCareerStatsAttacking}
                      aria-label="attacking">
                      {t("stats_attacking")}
                    </ToggleButton>

                    <ToggleButton className="mls-o-buttons__segment" value={statTypes.playersCareerStatsDefending}
                      aria-label="defending">
                      {t("stats_defending")}
                    </ToggleButton>
                  </ButtonGroup>
                )
                : (
                  <Dropdown
                    extraClass={"mobile"}
                    onChangeFn={(val) => setStatType(val)}
                    displayKey={"name"}
                    valueKey={"statType"}
                    items={[
                      {
                        statType: initialStatType,
                        name: t("stats_general")
                      },
                      {
                        statType: statTypes.playersCareerStatsPassing,
                        name: t("stats_passing")
                      },
                      {
                        statType: statTypes.playersCareerStatsAttacking,
                        name: t("stats_attacking")
                      },
                      {
                        statType: statTypes.playersCareerStatsDefending,
                        name: t("stats_defending")
                      }]}
                    currentValue={statType}
                  />
                )
            }
          </div>
          {
            statsLoading ||
              formatStatsData?.length ?
              <PlayersCareerTable
                baseClass={"mls-c-players-career-stats"}
                playerData={formatStatsData}
                order={order}
                setOrder={setOrder}
                statType={statType}
                emptyResultsComponent={
                  <></>
                }
              />
              :
              <div className="mls-c-stats__no-results">
                <NoResults size="large" />
                <div className="mls-c-stats__no-results-text">{t("no_match_log_available")}</div>
              </div>
          }
        </div>
        :
        <div className="mls-c-stats__no-results">
          <NoResults size="large" />
          <div className="mls-c-stats__no-results-text">{t("no_stats_available")}</div>
        </div>
      }
    </>
  );
}

// eslint-disable-next-line no-func-assign
PlayersCareerStats = React.memo(PlayersCareerStats);

export default PlayersCareerStats;
